import axios, { type AxiosError, type AxiosResponse } from "axios";
import { toast } from "react-toastify";

const new_api_public = axios.create({
  baseURL: import.meta.env.VITE_APP_NEW_BACKEND_ENDPOINT,
  timeout: 1000 * 30,
});

new_api_public.interceptors.response.use(
  (response: AxiosResponse) => Promise.resolve(response),

  (error: AxiosError) => {
    if (!error.response) {
      toast.error("Falha na conexão com o servidor");
      return Promise.reject(error);
    }

    if (error.response.status >= 400 && error.response.status <= 500) {
      const message =
        typeof error.response.data === "string"
          ? error.response.data
          : "Erro ao processar a requisição";
      toast.error(message);
    }

    if (error.response.status >= 500 || error.response.status === 0) {
      toast.error("Falha ao processar a solicitação");
    }

    return Promise.reject(error);
  },
);

export default new_api_public;
